var scope_0 = require('/vercel/path4/examples/mono-notes/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb308bdb3fb9da181352fb84888c2ae8.js').default;
var scope_1 = require('/vercel/path4/examples/mono-notes/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    